import React, { useCallback } from 'react'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { Button, Container, Row, Col } from 'reactstrap'
import { toast } from 'react-toastify'

import WhiteFooter from 'components/Footers/WhiteFooter.js'
import logoMural from 'assets/img/logo_mural_2.png'
import { UsersService } from 'services/users'
import { getUser, setToken } from 'services/auth'

const AgradecePage = ({ history }) => {
  const { executeRecaptcha } = useGoogleReCaptcha()

  const goBack = useCallback(() => {
    history.push('/')
  }, [history])

  const handleAccess = useCallback(async () => {
    const user = getUser()

    const Captcha = await executeRecaptcha('agradecer_pagina')

    try {
      const loginUserResponse = await UsersService.login({
        Login: user.Email,
        Senha: user.Senha,
        Captcha,
        ManterConectado: true,
      })

      if (loginUserResponse.status === 200) {
        setToken(loginUserResponse.data)
        history.push('/mural-aprovados-sisu')
      }
    } catch (e) {
      toast.error('Houve um erro inesperado. Por favor, tente novamente!')
    }
  }, [executeRecaptcha, history])

  return (
    <>
      <div className="section">
        <Container className="text-center">
          <Row>
            <Col style={{ textAlign: 'end' }}>
              <Button onClick={goBack} className="btn-round" color="#000">
                <span>X</span>
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <img src={logoMural} style={{ width: 260 }} alt="" />
            </Col>
          </Row>
          <Row>
            <Col className="ml-auto mr-auto text-center" md="12">
              <p
                className="description"
                style={{
                  fontWeight: 400,
                  color: '#000',
                  letterSpacing: 2,
                  lineHeight: 1.6,
                  marginTop: 30,
                }}
              >
                <span style={{ fontWeight: 600 }}>Obrigado</span> por se cadastrar em nossa plataforma.
              </p>
            </Col>
          </Row>
        </Container>

        <Container className="text-center" style={{ marginTop: 30, marginBottom: 30 }}>
          <Row>
            <Col>
              <Button
                onClick={handleAccess}
                className="btn-round"
                style={{
                  letterSpacing: 4,
                  border: 0,
                  backgroundColor: '#16057C',
                  paddingTop: 7,
                  cursor: 'pointer',
                  fontSize: 14,
                  textTransform: 'none',
                  fontWeight: 400,
                }}
              >
                <span style={{ fontWeight: 600 }}>Acessar</span> Mural de Aprovados
              </Button>
            </Col>
          </Row>
        </Container>

        <WhiteFooter />
      </div>
    </>
  )
}

export default AgradecePage
